// Get URL Parameter
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

// Doc ready
$(function() {

    var $developmentsContainer = $('.developments-container');
    var $developmentStatusSelect = $('.development-status-filter-js');

    // 
    $('.map-arrow').on("click", function() {
        $scrollHeight = $(document).height() - $(window).height();
        $('html, body').animate({
            scrollTop: 1000
        }, 1000);
    });

    // Developments filter
    $(".filter-btn").on('click',function () {
        $(this).addClass('active').siblings('.filter-btn').removeClass('active');
        if($(this).data("filter") == "map"){
            $(this).closest(".developments-container").removeClass("display-grid");
        }else{
            $(this).closest(".developments-container").addClass("display-grid");
        }
    })

    // Development Status Select
    if ( $developmentStatusSelect.length ) {

        // If URL Param set the update status
        if ( getUrlParameter('devstatus') ) {
            setTimeout(() => {
                $developmentStatusSelect.val(getUrlParameter('devstatus')).trigger("change");
            }, 400);  
        }

        // Development Status trigger select
        $(".developments-status-list-js").on('click',function () {
            $developmentStatusSelect.select2('open');
        })
        
        // Filter Developments in list
        $developmentStatusSelect.on( 'change', function(e) {
            var filterValue = $(this).val();

            $developmentsContainer.find('.dev-item').removeClass('is-hidden'); // Show All
            // Filter items
            if(filterValue != 'all') {
                $developmentsContainer.find('.dev-item:not([data-status~="'+filterValue+'"])').addClass('is-hidden');
            }
        });
    }

    // Fade in Map icons at random intervals
    $developmentsContainer.find('.map-container').addClass('anim-start');
    $developmentsContainer.find('.map-container .dev-item').each(function(){
        var $this = $(this);
        setTimeout(function(){ 
            $this.fadeTo('slow', 1).addClass('anim-init'); 
        }, Math.floor(Math.random()*1500));
    });

    
});
